
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import * as uuid from 'uuid';
import {TreeNode} from 'primeng/api';
import { mensaService } from '../../gestione-mensa.service';
import { HtmlEditorService, QuickToolbarService, ToolbarService, ToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
import * as moment from 'moment';

@Component({
  selector: 'app-sospensioni-edit',
  templateUrl: './sospensioni-edit.component.html',
  styleUrls: ['./sospensioni-edit.component.css'],
  providers: [MessageService,ConfirmationService,ToolbarService, HtmlEditorService, QuickToolbarService],
  encapsulation: ViewEncapsulation.None
})
export class SospensioniEditComponent implements OnInit {
  @ViewChild('maintablepranzo') maintablepranzo:any;
  @ViewChild('maintablecena') maintablecena:any;
  
  primaData=new Date();

  pageTitle:string="";
  id:any='';
  backUrl:string='dashboard/gestionemensa/sospensioni';
  ricetteList:any[]=[];
  pastoList:any []=[
    {value:'',label:'Pranzo e cena'},
    {value:'pranzo',label:'Pranzo'},
    {value:'cena',label:'Cena'}
  ];
  action:any='';
  
    public tools: ToolbarSettingsModel = {
      type: 'Expand' as ToolbarSettingsModel['type'],
      items: ['Bold', 'Italic', 'Underline', 'OrderedList',
          'UnorderedList']};
  
  camerasList:any=[];
  loading:boolean = true;
  selectedItems:any[]=[];
  elencoPiattiPranzo: any = [];
 
  sosp:any={
    struttura_id:0,
    dal_giorno:null,
    al_giorno:null,
    motivazione:''
  };
 
 
  constructor(
    private apiService: ApiService,
    public confirmationService: ConfirmationService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public router: Router,
    private mensaservice: mensaService,
  ) { }


  ngOnInit(): void {
  
    
    this.action=this.route.snapshot.paramMap.get('action');
    this.id=this.route.snapshot.paramMap.get('id');
    this.sosp.struttura_id=this.route.snapshot.paramMap.get('struttura_id');
    this.pageTitle=this.route.snapshot.paramMap.get('struttura_name');
   
    this.apiService.post('mensa/mensa_sospensioni_listall',{id:this.id}).subscribe(data => {
      if(data.Result && data.Result[0]){
        this.sosp.dal_giorno=new Date(data.Result[0].dal_giorno);
        this.sosp.al_giorno=new Date(data.Result[0].al_giorno);
        this.sosp.motivazione=data.Result[0].motivazione;
      }
      this.loading=false;
    });
  
  }

  valida(){
    return true;
  }

  salvaeconferma(){
    let today=new Date().getTime();
    if(!this.sosp.dal_giorno || !this.sosp.al_giorno || this.sosp.dal_giorno.getTime() >this.sosp.al_giorno.getTime() ){
       this.addSingle('error', 'Errore', 'Periodo non corretto');
       return;
    }
     if(this.sosp.dal_giorno<today || this.sosp.al_giorno<today ){
       this.addSingle('error', 'Errore', 'Periodo non corretto: le date devono essere maggiori di quella odierna');
       return;
    }
  
    
    this.confirmationService.confirm({
        target: event.target as EventTarget,
        message: 'Si conferma la sospensione?',
        header: 'Attenzione',
        accept: () => {
          this.salva(1);
        },
        reject: () => {
          
        },
    });
  }
  
  salva(what){
    
    let cprogr:any={

      struttura_id:this.sosp.struttura_id,
      dal_giorno:this.sosp.dal_giorno,
      al_giorno:this.sosp.al_giorno,
      pasto:this.sosp.pasto,
      motivazione:this.sosp.motivazione
    };
    
    if(this.id){
      cprogr.id=this.id
    }
   
    
    this.apiService.post('mensa/mensa_sospensione_update',cprogr).subscribe(data => {
      this.addSingle('success', 'Successo', 'Record aggiornato ');
      setTimeout(()=>{
        this.router.navigateByUrl(this.backUrl);
      },1500);
      
    });
  }
  
  
  delete(){

  }

  annulla(){
    this.router.navigateByUrl(this.backUrl);
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }


  onRowEditCancelPranzo(ev:any){

  }
  deleteSezionePranzo(ev:any,list:any){
    
    list.forEach((c:any,ind:number)=>{
      if(c.id==ev.id){
        list.splice(ind,1);
      }
    });
   
  }

  onRowEditSavePranzo(ev:any){
    
  }
  onRowEditSaveCena(ev:any){
    
  }
  
  onRowEditInitCena(ev:any){
    
  }
  onRowEditInitPranzo(ev:any){
    
  }
  
  
  
  
  
}
